// extracted by mini-css-extract-plugin
export default {"portrait":"grid-portrait_portrait__sRHeQ","image":"grid-portrait_image__iebMX"};